import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import LearnPage from '@src/pages/Learn';

export const Route = createFileRoute('/learn')({
  head: () => buildSeoHead({ path: '/learn', ...ROUTE_META['/learn'] }),
  component: LearnPageWithLayout,
});

function LearnPageWithLayout() {
  return (
    <DefaultLayout>
      <LearnPage />
    </DefaultLayout>
  );
}
